// Are we running inside the native iOS/Android shell (Capacitor) rather than
// a browser tab / installed PWA? Used to hide web-only UI (install hints,
// web-push settings) and to apply native-feel styling. Evaluated once — the
// platform cannot change at runtime.
import { Capacitor } from '@capacitor/core';

export const isNativeApp = Capacitor.isNativePlatform();
